import { useState } from "react";
import InputForm from "../../componentes/input/input";
import SuporteService from "../../services/resource/SuporteService";

export default function ContatoSuporteForm({
    onClose,
    submitMode = "json-base64" }) {
    const service = new SuporteService();
    const [form, setForm] = useState({
        nome: "",
        email: "",
        assunto: "",
        mensagem: "",
        anexos: [],
    });

    const [files, setFiles] = useState([]);
    const [errors, setErrors] = useState({});
    const [sending, setSending] = useState(false);
    const [success, setSuccess] = useState(false);
    const [fail, setFail] = useState(null);

    // validação simples
    const validate = () => {
        const e = {};
        if (!form.nome.trim()) e.nome = "Informe seu nome.";
        if (!form.email.trim()) e.email = "Informe seu e-mail.";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
            e.email = "E-mail inválido.";
        if (!form.assunto.trim()) e.assunto = "Informe o assunto.";
        if (!form.mensagem.trim()) e.mensagem = "Descreva sua solicitação.";

        setErrors(e);
        return Object.keys(e).length === 0;
    };

    // converter arquivos para base64
    const filesToBase64 = async (selected) => {
        const toB64 = (file) =>
            new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () =>
                    resolve(String(reader.result).split(",")[1]); // carrega só o payload base64
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });

        return Promise.all(selected.map((f) => toB64(f)));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFail(null);

        if (!validate()) return;

        try {
            setSending(true);

            if (submitMode === "json-base64") {
                const anexosB64 = await filesToBase64(files);

                const payload = {
                    nome: form.nome,
                    email: form.email,
                    assunto: form.assunto,
                    mensagem: form.mensagem,
                    anexos: anexosB64, // lista de { nome, tipo, base64 }
                };

                service.contactarSuporte(payload).then(res => {

                }).catch(err => {
                    new Error(`Falha ao enviar (${err.status})`)
                })
            } else {
                const fd = new FormData();
                fd.append("nome", form.nome);
                fd.append("email", form.email);
                fd.append("assunto", form.assunto);
                fd.append("mensagem", form.mensagem);

                // Spring recebe como @RequestParam("anexos") MultipartFile[]
                files.forEach((file) => {
                    fd.append("anexos", file);
                });

                service.contactarSuporte(fd).then(res => {

                }).catch(err => {
                    new Error(`Falha ao enviar (${err.status})`)
                })
            }

            setSuccess(true);

            setForm({
                nome: "",
                email: "",
                assunto: "",
                mensagem: "",
            });

            setFiles([]);
        } catch (err) {
            setFail(err?.message ?? "Não foi possível enviar sua mensagem.");
        } finally {
            setSending(false);
        }
    };

    if (success) {
        return (
            <div className="flex w-full h-[100vh]">
                <div className="p-6 max-w-xl mx-auto text-center">
                    <i className="fa fa-check-circle text-[150px] text-success mb-3" />

                    <h2 className="font-display text-2xl font-semibold text-success">
                        Mensagem enviada com sucesso!
                    </h2>

                    <p className="mt-3 text-muted-foreground">
                        Agradecemos pelo contato! Nossa equipe irá responder em breve.
                    </p>

                    <a
                        href="/"
                        className="inline-block mt-6 px-4 py-2 rounded-md bg-primary text-primary-foreground transition-colors duration-150 hover:brightness-95"
                    >
                        Voltar para tela inicial
                    </a>
                </div>
            </div>
        );
    }

    return (
        <div className="p-4 max-w-3xl mx-auto">
            <div className="w-full surface-card">
                <div className="px-6 py-3 border-b border-border">
                    <h2 className="font-display text-xl font-semibold text-foreground">Contatar o Suporte</h2>
                    <p className="mt-1 text-sm text-muted-foreground">
                        Preencha os dados abaixo e descreva o problema ou solicitação.
                    </p>
                </div>

                <form onSubmit={handleSubmit} className="px-6 py-6 grid grid-cols-1 gap-2 md:grid-cols-4">

                    {/* Nome */}
                    <div className="col-span-2">
                        <InputForm
                            label="Nome"
                            type="text"
                            className="mt-1 w-full"
                            value={form.nome}
                            onChange={(e) => setForm({ ...form, nome: e.target.value })}
                            placeholder="Seu nome completo"
                        />
                        {errors.nome && <p className="mt-1 text-xs text-destructive">{errors.nome}</p>}
                    </div>

                    {/* Email */}
                    <div className="col-span-2">
                        <InputForm
                            label="E-mail"
                            type="email"
                            className="mt-1 w-full"
                            value={form.email}
                            onChange={(e) => setForm({ ...form, email: e.target.value })}
                            placeholder="seuemail@exemplo.com"
                        />
                        {errors.email && <p className="mt-1 text-xs text-destructive">{errors.email}</p>}
                    </div>

                    {/* Assunto */}
                    <div className="col-span-4">
                        <InputForm
                            label="Assunto"
                            type="text"
                            className="mt-1 w-full"
                            value={form.assunto}
                            onChange={(e) => setForm({ ...form, assunto: e.target.value })}
                            placeholder="Ex.: Erro ao emitir relatório"
                        />
                        {errors.assunto && <p className="mt-1 text-xs text-destructive">{errors.assunto}</p>}
                    </div>

                    {/* Mensagem */}
                    <div className="col-span-4">
                        <label className="block text-sm font-medium text-foreground/80">Mensagem</label>
                        <textarea
                            rows={5}
                            className="w-full px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/15 focus:border-primary disabled:bg-muted transition-all duration-150"
                            value={form.mensagem}
                            onChange={(e) => setForm({ ...form, mensagem: e.target.value })}
                            placeholder="Descreva o que aconteceu, passos para reproduzir, etc."
                        />
                        {errors.mensagem && (
                            <p className="mt-1 text-xs text-destructive">{errors.mensagem}</p>
                        )}
                    </div>

                    {/* Anexos */}
                    <div className="col-span-4">
                        <label className="block text-sm font-medium text-foreground/80">
                            Anexos (opcional)
                        </label>
                        <input
                            type="file"
                            multiple
                            className="mt-1 block w-full text-sm text-muted-foreground file:mr-4 file:rounded-md file:border-0 file:bg-accent file:px-3 file:py-2 file:text-accent-foreground hover:file:brightness-95 file:transition-all file:duration-150"
                            onChange={(e) => {
                                const selected = Array.from(e.target.files || []);
                                setFiles(selected);
                            }}
                        />
                    </div>

                    <div className="col-span-4">
                        {fail && <p className="text-sm text-destructive">{fail}</p>}
                    </div>

                    <div className="col-span-4 flex justify-end gap-3">
                        {onClose && (
                            <button
                                type="button"
                                onClick={onClose}
                                className="px-4 py-2 rounded-md bg-muted hover:bg-muted/70 text-foreground transition-colors duration-150"
                            >
                                Cancelar
                            </button>
                        )}
                        <a
                            type="button"
                            href="/"
                            disabled={sending}
                            className="px-4 py-2 rounded-md bg-muted hover:bg-muted/70 hover:text-foreground text-foreground disabled:opacity-50 hover:no-underline transition-colors duration-150"
                        >
                            Voltar para tela inicial
                        </a>
                        <button
                            type="submit"
                            disabled={sending}
                            className="px-4 py-2 rounded-md bg-primary hover:brightness-95 text-primary-foreground disabled:opacity-50 transition-all duration-150"
                        >
                            {sending ? "Enviando..." : "Enviar Mensagem"}
                        </button>


                    </div>
                </form>
            </div>
        </div>
    );
}
